module.exports = __webpack_public_path__ + "img/invitationCode.6546431f.png";